"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTicketTransferredMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const buildTicketTransferredMockData = ({ organizationName, color, isDarkMode, locale = "en", firstName = "Jordan", ticketingName = "Spring Gala 2026", rateNames = ["2x General admission", "1x VIP"], oldOccurrenceStart = "May 12, 2026 at 7:00 PM", newOccurrenceStart = "June 9, 2026 at 7:00 PM", eticketUrl = "https://storage.zeffy.com/e-tickets/dev-action-tickets.pdf", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    return {
        theme,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        labels: (0, email_templates_1.getEmailLabels)(locale),
        lang: locale,
        isPreview: false,
        subject: "Your tickets have been updated",
        orgName: organizationName || "Bright Futures Foundation",
        firstName,
        ticketingName,
        rateNames,
        oldOccurrenceStart,
        newOccurrenceStart,
        eticketUrl,
    };
};
exports.buildTicketTransferredMockData = buildTicketTransferredMockData;
